import React, { useState, useEffect } from 'react';
import { accountApi, salesApi, userApi } from '../../api';
import { PageHeader, StatCard } from '../../components/common';

const AdminDashboard = () => {
  const [accountStats, setAccountStats] = useState(null);
  const [salesStats, setSalesStats] = useState(null);
  const [userCount, setUserCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [accRes, salesRes, userRes] = await Promise.all([
          accountApi.getStatistics(),
          salesApi.getStatistics(),
          userApi.getList({ per_page: 1 })
        ]);
        setAccountStats(accRes.data);
        setSalesStats(salesRes.data);
        setUserCount(userRes.data.total);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div>
      <PageHeader title="管理员仪表盘" />

      <h3 style={{ marginBottom: '15px' }}>账号统计</h3>
      <div className="stats-grid">
        <StatCard title="总账号数" value={accountStats?.total || 0} color="#1890ff" />
        <StatCard title="可用账号" value={accountStats?.available || 0} color="#52c41a" />
        <StatCard title="已售账号" value={accountStats?.sold || 0} color="#faad14" />
        <StatCard title="已禁用" value={accountStats?.disabled || 0} color="#ff4d4f" />
      </div>

      <h3 style={{ marginBottom: '15px' }}>销售统计</h3>
      <div className="stats-grid">
        <StatCard title="总销售记录" value={salesStats?.total || 0} color="#1890ff" />
        <StatCard title="已发号" value={salesStats?.delivered || 0} color="#52c41a" />
        <StatCard title="已结算" value={salesStats?.settled || 0} color="#722ed1" />
        <StatCard title="待绑定" value={salesStats?.pending || 0} color="#faad14" />
      </div>

      <h3 style={{ marginBottom: '15px' }}>金额统计</h3>
      <div className="stats-grid">
        <StatCard title="总金额" value={`¥${(salesStats?.total_amount || 0).toFixed(2)}`} color="#1890ff" />
        <StatCard title="已结算金额" value={`¥${(salesStats?.settled_amount || 0).toFixed(2)}`} color="#52c41a" />
        <StatCard title="用户总数" value={userCount} color="#722ed1" />
      </div>
    </div>
  );
};

export default AdminDashboard;
